import { on } from '@ember/modifier';

import { t } from 'ember-intl';
import onKey from 'ember-keyboard/modifiers/on-key';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../styles.module.css';

const bem = getBem(styles);

<template>
  <div class={{(bem)}} ...attributes>
    <h2 class={{bem 'title'}}>
      {{t @confirm.title}}
    </h2>
    <div class={{bem 'message'}}>
      {{t @confirm.message htmlSafe=true}}
    </div>

    <Button
      @label={{t 'application.confirm.default.confirm'}}
      @style='primary'
      {{on 'click' @confirm.confirm}}
      {{onKey 'Enter' @confirm.confirm}}
    />

    <Button
      @label={{t 'application.confirm.default.cancel'}}
      @style='outline'
      {{on 'click' @confirm.cancel}}
      {{onKey 'Escape' @confirm.cancel}}
    />
  </div>
</template>
